import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EarlyAccessCreateUserPage' })(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      marginBottom: 'var(--ebl-s2) !important',
    },
  },
  title: {
    marginTop: 'var(--ebl-s2)',
  },
  error: {
    marginTop: 'var(--ebl-s2)',
  },
}));
